import React from "react";
import { Link } from "react-router-dom";

const tabs = [
  { key: "Requirement", label: "Requirements" },
  { key: "CSR Internship", label: "CSR Internship" },
  { key: "Training", label: "Training" },
];

export default function CareerTabs({ activeTab }) {
  return (
    <div className="sticky top-0 bg-white shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8 border-b">
          {tabs.map(({ key, label }) => (
            <Link
              key={key}
              to={`/Careers?tab=${encodeURIComponent(key)}`}
              className={`py-2 px-4 text-lg font-semibold transition-all no-underline outline-none
                ${
                  activeTab === key
                    ? "border-b-4 border-blue-500 text-blue-600"
                    : "text-gray-600 hover:text-blue-500"
                }`}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
